import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { BookmarkSortModel } from 'src/app/bookmarks/models/bookmark-sort.model';

export class Load {
  static readonly type = '[Explore] Load';
  constructor(public category: string) { }
}

export class Search {
  static readonly type = '[Explore] Search';
  constructor(public query: string) { }
}

export class SetSearching {
  static readonly type = '[Explore] Set Searching';
  constructor(public searching: boolean) { }
}

export class LoadSuccess {
  static readonly type = '[Explore] Load Success';
  constructor(public searchResults: BookmarkModel[]) { }
}

export class SortSearchResults {
  static readonly type = '[Explore] Sort';
  constructor(public sort: BookmarkSortModel) { }
}

export class ResetSearchResults {
  static readonly type = '[Explore] Reset Search Results';
  constructor() { }
}

export class CheckSearchResult {
  static readonly type = '[Explore] Check Search Result';
  constructor(public id: string, public checked: boolean) { }
}

export class SetCheckedSearchResults {
  static readonly type = '[Explore] Set Checked Search Results';
  constructor(public ids: string[]) { }
}

export class SelectCategory {
  static readonly type = '[Explore] Select Category';
  constructor(public tag: string) { }
}

export class ResetExplore {
  static readonly type = '[Explore] Reset';
  constructor() { }
}
